import React from 'react';
import { IMSelect } from '@insurancemenu/imenu-components-lib/dist/components/imForm';
import { observer } from 'mobx-react-lite';
import { useAlliedBrokerPageStore } from 'store/pages/enrollment/broker/broker-allied/pageStore';
import { toJS } from 'mobx';
import { ContentSection } from 'components/common/general/ContentSection';
import { TIN_AND_GA_FORM_ID } from '../constants';
import { IMFormStyled } from './styles';

export const SelectAgentForm: React.FC = observer(() => {
  const {
    selectAgentDelegate: { form, isFormBlocked, agentOptions },
  } = useAlliedBrokerPageStore();

  const guidelines = isFormBlocked
    ? 'Select the agent TIN and general agency to enable choosing an associated agent'
    : undefined;

  return (
    <ContentSection title="Select Agent" subtitle="Choose an existing agent or add a new one if none match">
      <IMFormStyled id={TIN_AND_GA_FORM_ID} formController={form}>
        <IMSelect
          label="Agent of Record"
          name="agentOfRecord"
          size="full"
          options={agentOptions.slice().map((option) => toJS(option))}
          disabled={isFormBlocked}
          guidelines={guidelines}
        />
      </IMFormStyled>
    </ContentSection>
  );
});
